import { Card, CardBody, Col, Container } from 'reactstrap'
import { Breadcrumbs } from '../../../../AbstractElements'
import { Cart, ECommerce } from '../../../../Constants/Constants'
import CommonCardHeader from '../../../CommonComponents/CommonCardHeader/CommonCardHeader'
import { CartData } from './CartData'

const CartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Cart} parent={ECommerce} />
      <Container fluid>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={Cart} />
            <CardBody>
              <CartData />
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  )
}

export default CartContainer